//Default Swiper
// slick default setting
let defaulsettings = {
	loop: true,
	speed: 700,
	effect: 'fade',
	fadeEffect: { 
    crossFade: true 
  },
	navigation: { 
    nextEl: '.swiper-prev', 
    prevEl: '.swiper-next' 
  },
	autoplay: { 
    delay: 5000, 
    disableOnInteraction: false 
  }
}

// start slider default
let allSwipper = []

document.querySelectorAll('.swiper-js').forEach((element, i) => {
	let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;

	element.setAttribute(`data-swiper-${i}`, '')

	let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig)

	allSwipper[i] = swiper
})

document.querySelectorAll('[data-swiper-control]').forEach((mainSlider) => {
	const selectorsLinked = mainSlider.dataset.swiperControl ? JSON.parse(mainSlider.dataset.swiperControl) : [];
	if (selectorsLinked.length < 1) {
		return false;
	}

	const slidersLinked = selectorsLinked
		.map((selector) => {
			return [...document.querySelectorAll(selector)].map((el) => el.swiper);
		})
		.flat();
	mainSlider.swiper.controller.control = slidersLinked;
});


const other_swiper = new Swiper(".small-main-galley-js", {
  rewind: true,
  spedd: 700,
  navigation: {
    nextEl: ".gallery-next-js",
    prevEl: ".gallery-prev-js"
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false
  }
});
let awardSlider = new Swiper('.slider-awards__slider',{
  loop: true,
  speed: 700,
  slidesPerView: 3,
  centerMode: true,
  spaceBetween: 20,
  fadeEffect: {
      crossFade: true
  },
  navigation: {
      prevEl: '.award-prev',
      nextEl: '.award-next'
  }
})
let awardSliderMobile = new Swiper('.slider-awards__mobile',{
  loop: true,
  speed: 700,
  slidesPerView: 1,
  centerMode: true,
  spaceBetween: 20,
  fadeEffect: {
      crossFade: true
  },
  navigation: {
      prevEl: '.award-prev',
      nextEl: '.award-next'
  }
})

const main_swiper = new Swiper(".small-galley-other-js", {
  spedd: 700,
  slidesPerView: "auto",
  rewind: true
});

other_swiper.controller.control = main_swiper;
main_swiper.controller.control = other_swiper;